import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import RestoreIcon from '@mui/icons-material/Restore';
import Box from '@mui/material/Box';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import MiViewTacticCard from '../MiViewTacticCard/MiViewTacticCard';
import useMiViewCEPAccordion from './MiViewCEPAccordion.hook';
import {
  accordionHeaderStyle,
  percentBlockStyle,
  infoBoxStyle,
} from './MiViewCEPAccordion.style';
import { MiViewCEPAccordionProps } from './MiViewCEPAccordion.types';

const MiViewTargetAccordion: FC<MiViewCEPAccordionProps> = ({ cep, tactics, opened, IVADocuments, AEDocuments }) => {
  const {
    openedState,
    changeOpenState,
    formattedTactics,
  } = useMiViewCEPAccordion(tactics, opened);
  const { t } = useTranslation();

  return (
    <Box display="block">
      <Box sx={ accordionHeaderStyle } onClick={ changeOpenState }>
        <Box sx={ infoBoxStyle }>
          { openedState ? (<KeyboardArrowDownIcon/>) : (<KeyboardArrowRightIcon/>) }
          <Box sx={ percentBlockStyle }>{ t('maya_miview_percents_label') }</Box>
          <Box>{ cep?.title }</Box>
        </Box>

        <RestoreIcon></RestoreIcon>
      </Box>
      <Box sx={ { display: `${openedState ? 'block' : 'none'}` } }>
        {
          formattedTactics?.map((tactic, index) => (
            <MiViewTacticCard
              key={ index }
              tactic={ tactic }
              tactics={ tactics }
              AEDocuments={ AEDocuments }
              IVADocuments={ IVADocuments }
            >
            </MiViewTacticCard>
          ))
        }
      </Box>
    </Box>
  );
};

export default MiViewTargetAccordion;
